import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PoDialogService, PoDynamicFormField, PoLookupColumn, PoNotificationService, PoSelectOption } from '@po-ui/ng-components';
import { Fornecedor, getFornecedorDefault } from 'src/app/interface/fornecedor';
import { MunicipioIBGE } from 'src/app/interface/municpio-ibge';
import { AuthService } from 'src/app/service/auth.service';
import { CEPService } from 'src/app/service/cep-service';
import { FornecedorService } from 'src/app/service/fornecedor-service';
import { MunicipioIBGEService } from 'src/app/service/municipio-ibge-service';
import { UtilService } from 'src/app/service/util';
import { getProcessoCadastroRevisaoFornecedorDefault, ProcessoCadastroRevisaoFornecedor } from '../../../interface/processo-revisao-cadastro-fornecedor';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';

@Component({
  selector: 'app-revisao-cadastro-fornecedor-editar',
  templateUrl: './revisao-cadastro-fornecedor-editar.component.html',
  styleUrls: ['./revisao-cadastro-fornecedor-editar.component.css']
})
export class RevisaoCadastroFornecedorEditarComponent implements OnInit {

  chave: string;
  tenantid: string;
  bloqueiaConfirmar: boolean;
  fornecedorDto: ProcessoCadastroRevisaoFornecedor;
  fornecedorOriginal: Fornecedor;
  listaEstado: Array<PoSelectOption>;

  advancedMunicipioIBGEFilters: Array<PoDynamicFormField>;
  columnsMunicipioIBGEFilters: Array<PoLookupColumn>;
  fieldFormaterMunicipioIBGEFilters: ((value: MunicipioIBGE) => string);

  constructor(
    private route: ActivatedRoute,
    public fornecedorService: FornecedorService,
    public processoCadastroService: ProcessoCadastroService,
    public municipioIBGEService: MunicipioIBGEService,
    private poDialog: PoDialogService,
    private poNotification: PoNotificationService,
    private authService: AuthService,
    public utilService: UtilService,
    public cepService: CEPService,
  ) {
    this.chave = '';
    this.tenantid = '';
    this.bloqueiaConfirmar = true;
    this.fornecedorDto = getProcessoCadastroRevisaoFornecedorDefault();
    this.fornecedorOriginal = getFornecedorDefault();
    this.listaEstado = utilService.getListaEstados();

    sessionStorage.clear();


    this.advancedMunicipioIBGEFilters = this.municipioIBGEService.getAdvancedFilter();
    this.columnsMunicipioIBGEFilters = this.municipioIBGEService.getColumnsFilter();
    this.fieldFormaterMunicipioIBGEFilters = this.municipioIBGEService.getFieldFormater;
  }

  @ViewChild('formCadastroFornecedor', { static: true }) formCadastroFornecedor!: NgForm;

  ngOnInit(): void {

    this.authService.autoLogin('portal', '9bLkksY,Q6').then(() => {
      this.route.params.subscribe((params) => {
        if ('chave' in params) {
          this.chave = params['chave'];

          sessionStorage.setItem('CUSRID', '000268');
          sessionStorage.setItem('tenantid', '01,01');

          this.processoCadastroService.getFornecedorSA2(this.chave).subscribe(fornecedorDto => {
            this.fornecedorDto = { ...fornecedorDto };
            this.fornecedorOriginal = { ...fornecedorDto.fornecedor };
            this.municipioIBGEService.estado = this.fornecedorDto.fornecedor.CA2EST;
            this.fornecedorDto.fornecedor.CA2NATUREZ = this.fornecedorOriginal.CA2NATUREZ
          }, (e) => {
            this.poDialog.alert({
              title: 'ATENÇÃO',
              message: 'CHAVE INVÁLIDA OU FORMULÁRIO JÁ PREENCHIDO ANTERIORMENTE. CASO TENHA DÚVIDA, FAVOR EM CONTATO COM SOLIDA.',
              ok: () => this.redirecionar()
            });

          });
        }
      })
    })
  }

  openModalConfirmar() {
    if (this.fornecedorDto.fornecedor.CA2BANCO != '' && (this.fornecedorDto.fornecedor.CA2AGENCIA == '' || this.fornecedorDto.fornecedor.CA2NUMCON == '')){
      this.poNotification.warning("Dados bancários inválidos. Por favor, preencha os dados bancários corretamente.")
    } else {
      this.poDialog.confirm({
        title: 'Confirmar Cadastro',
        message: 'Deseja realmente confirmar os dados apresentados?',
        confirm: () => this.salvar()
      });
    }
  }

  salvar() {

    this.fornecedorDto.COBSERVACAO = `CONFIRMACAO FORNECEDOR - ${this.fornecedorDto.COBSERVACAO}`;

    this.processoCadastroService.postFornecedorTemporario(this.fornecedorDto).subscribe(() => {
      this.poDialog.alert({
        title: 'Dados Enviados',
        message: 'Dados enviados com sucesso! Agradecemos pela parceria de sempre.',
        ok: () => this.redirecionar()
      });

    });

  }

  redirecionar() {
    window.location.href = 'http://www.solidabrasil.com.br';
  }

  validForm(): boolean {
    return !(this.formCadastroFornecedor.valid);
  }

  alteraCep() {
    this.cepService.getObjectByValue(this.fornecedorDto.fornecedor.CA2CEP).subscribe(cep => {
      if (cep.cep) {
        this.fornecedorDto.fornecedor.CA2END = `${cep.logradouro.toUpperCase()}, `;
        this.fornecedorDto.fornecedor.CA2BAIRRO = cep.bairro.toUpperCase();
        this.fornecedorDto.fornecedor.CA2EST = cep.uf;
        this.fornecedorDto.fornecedor.CA2COD_MUN = cep.ibge.substring(2, 7);
        this.municipioIBGEService.estado = cep.uf;
      } else {
        this.fornecedorDto.fornecedor.CA2END = '';
        this.fornecedorDto.fornecedor.CA2BAIRRO = '';
        this.fornecedorDto.fornecedor.CA2EST = '';
        this.fornecedorDto.fornecedor.CA2COD_MUN = '';
        this.municipioIBGEService.estado = '';
      }
    });

  }

  municipioIBGESelecionado(row: MunicipioIBGE) {
    this.fornecedorDto.fornecedor.CA2MUN = row.CCC2MUN;
  }



}

